import React from 'react';
import HarbourIcon from './HarbourIcon';
import './harbour.css';

/*
 * Harbour tick row: the kit's Checkbox card as a full-width action row (Figma
 * Harbour/Checkbox card, 916:2969). Rest is the canvas surface with a
 * control-stroke box; ticked is the SEN wash with a green box and white tick —
 * selection reads as filled surface + control change + label, never a hue
 * shift alone. A real checkbox to assistive tech.
 *
 * Ticks go both ways with no confirm step (Tom's 19 Oct design sweep): a
 * click or Space toggles, and onToggle receives the new state. `detail` is
 * an optional label and value shown under a ticked row (the meeting's date).
 */
export default function HarbourTickRow({ label, ticked = false, disabled = false, onToggle, detail = null }) {
  const activate = () => {
    if (!disabled && typeof onToggle === 'function') onToggle(!ticked);
  };
  return (
    <>
    <div
      role="checkbox"
      aria-checked={ticked}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : 0}
      className={[
        'harbour-tick-row',
        ticked ? 'harbour-tick-row--ticked' : '',
        disabled && !ticked ? 'harbour-tick-row--disabled' : '',
      ].filter(Boolean).join(' ')}
      onClick={activate}
      onKeyDown={(e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          activate();
        }
      }}
    >
      <span className="harbour-tick-row__box" aria-hidden="true">
        {ticked && <HarbourIcon name="check" size={16} />}
      </span>
      <span className="harbour-tick-row__label">{label}</span>
    </div>
    {ticked && detail && (
      <div className="harbour-tick-row__detail">
        <span className="harbour-tick-row__detail-label">{detail.label}</span>
        <span>{detail.value}</span>
      </div>
    )}
    </>
  );
}
